import { BlogPost } from '@/types/blog';
import { BlogCard } from '@/components/organisms';
import { getTranslate } from '@/tolgee/server';

export const blogPosts: BlogPost[] = [
  {
    id: 2,
    // title: 'The Season’s Hottest Trends',
    excerpt:
      'You can use our live streaming service to interact with customers in real time.',
    image: '/fbe/b2.png',
    category: 'STYLE GUIDE',
    href: 'https://live.incastbox.com',
  },
  {
    id: 3,
    // title: 'Minimalist Outerwear Trends',
    excerpt:
      'AI-generated store, let AI help you sell your products and communicate with customers about any issues.',
    image: '/fbe/b3.png',
    category: 'TRENDS',
    href: '/ai-chat',
  },
  {
    id: 1,
    // title: "Summer's Most Elegant Accessories",
    excerpt:
      "We continue to update our own media traffic technology to increase product exposure.",
    image: '/fbe/b1.png',
    category: 'ACCESSORIES',
    href: '',
  },
];

export async function BlogSection() {
  const t = await getTranslate()
  return (
    <section className='bg-tertiary container'>
      <div className='flex items-center justify-between'>
        <h2 className='heading-lg text-tertiary'>
          {t("blog.title")}
        </h2>
      </div>
      <div className='grid grid-cols-1 lg:grid-cols-3'>
        {blogPosts.map((post, index) => (
          <BlogCard
            key={post.id}
            index={index}
            post={post}
          />
        ))}
      </div>
    </section>
  );
}
